export default __webpack_public_path__ + "static/media/Certification.8a6fefa2.jpg";